







import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import RemittanceResourceList from '@superUI/ResourceList/RemittanceResourceList'
import CsvExportResourceTriggerModal from '@triggers/Utils/CsvExportResourceTriggerModal'
import ToggleDeliveryFlagTriggerModal from '@triggers/Remittance/ToggleDeliveryFlagTriggerModal'

settings =
  name: 'RemittanceList'
  components: { SuperContainerView, RemittanceResourceList, CsvExportResourceTriggerModal, ToggleDeliveryFlagTriggerModal }

  resources:
    remittances:
      resourceName: 'remittance'
      slug: 'remittances'
      infinityScroll: true

  vue:
    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      csvExportResourceTrigger: (payloadOptions) ->
        @$refs.csvExportResourceTrigger.fire(@exportCsvParams('remittances', payloadOptions))
      onRemittancesCsvExport: ->
        @$refs.csvExportResourceTrigger.close()

      downloadRemittanceCSV: (remittance) ->
        @triggerResource 'remittances', 'download_remittance', { remittance_id: remittance.id }

      toggleDeliveryFlagTrigger: (remittance) ->
        payloadOptions = { remittance_id: remittance.id }
        modalOptions = { remittance }
        @$refs.toggleDeliveryFlagTrigger.fire(payloadOptions, modalOptions)
      onRemittancesToggleDeliveryFlag: (data, response) ->
        @clearDataForResourceKey('remittances')
        @fetch('remittances')
        @$refs.toggleDeliveryFlagTrigger.close()

export default VueOptions.vue settings
